var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.00813V1H0.666687V9.66667H16V6.28455",
    stroke: "#132A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3H4.66667",
    stroke: "#132A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5H8",
    stroke: "#276E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H7.33333",
    stroke: "#132A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 3.66667V3",
    stroke: "#276E91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.3335V7.00016",
    stroke: "#276E91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2084 4.33317C13.2084 4.24562 13.1922 4.15893 13.1608 4.07805C13.1294 3.99716 13.0834 3.92367 13.0253 3.86177C12.9673 3.79986 12.8984 3.75075 12.8226 3.71725C12.7467 3.68375 12.6655 3.6665 12.5834 3.6665H12.0209C11.8551 3.6665 11.6961 3.73674 11.5789 3.86177C11.4617 3.98679 11.3959 4.15636 11.3959 4.33317C11.3959 4.50998 11.4617 4.67955 11.5789 4.80458C11.6961 4.9296 11.8551 4.99984 12.0209 4.99984H12.7084C12.8741 4.99984 13.0331 5.07008 13.1503 5.1951C13.2675 5.32012 13.3334 5.48969 13.3334 5.6665C13.3334 5.84332 13.2675 6.01288 13.1503 6.13791C13.0331 6.26293 12.8741 6.33317 12.7084 6.33317H11.9584C11.7926 6.33317 11.6336 6.26293 11.5164 6.13791C11.3992 6.01288 11.3334 5.84332 11.3334 5.6665",
    stroke: "#276E91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 5.00016C15.8508 5.00016 16 4.85092 16 4.66683C16 4.48273 15.8508 4.3335 15.6667 4.3335C15.4826 4.3335 15.3334 4.48273 15.3334 4.66683C15.3334 4.85092 15.4826 5.00016 15.6667 5.00016Z",
    fill: "#276E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/cheque.6c9f545aad91d48f59d9d7753f42f9b5.svg";
export { ForwardRef as ReactComponent };